import type { GeoPoint } from '@/signalr';
import { MapLinkServices } from '../model/psapConfiguration';

export type ExternalMapLinkModel = {
  iconPath: string;
  altText: string;
  link: string;
};

export type ExternalMapLinkTexts = {
  mapyCzAltText: string;
  googleMapsAltText: string;
};

function formatDecimalInvariant(value: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 5,
    maximumFractionDigits: 5,
  }).format(value);
}

function urlFormatCoordinates(coordinates: GeoPoint, separator: string, invert = false): string {
  if (invert) {
    return `${formatDecimalInvariant(coordinates.longitude)}${separator}${formatDecimalInvariant(coordinates.latitude)}`;
  }
  return `${formatDecimalInvariant(coordinates.latitude)}${separator}${formatDecimalInvariant(coordinates.longitude)}`;
}

export function createMapLinkModel(
  service: MapLinkServices,
  coordinates: GeoPoint,
  texts: ExternalMapLinkTexts,
): ExternalMapLinkModel {
  switch (service) {
    case MapLinkServices.MapyCz: {
      const mapyCzLink = `https://mapy.cz/turisticka?z=17&x=${urlFormatCoordinates(coordinates, '&y=', true)}&source=coor&id=${urlFormatCoordinates(coordinates, ',', true)}`;
      return { iconPath: 'Images/Icons/icon-mapy.svg', altText: texts.mapyCzAltText, link: mapyCzLink };
    }
    case MapLinkServices.GoogleMaps: {
      const googleMapLink = `https://www.google.com/maps/place/${urlFormatCoordinates(coordinates, ',')}/${urlFormatCoordinates(coordinates, ',')},17z`;
      return { iconPath: 'Images/Icons/icon-maps.svg', altText: texts.googleMapsAltText, link: googleMapLink };
    }
    case MapLinkServices.AirNavPro: {
      const airNavProLink = `airnavpro://direct-to?coordinates=wgs84-decimal&location=${urlFormatCoordinates(coordinates, '_')}`;
      return { iconPath: 'Images/Icons/icon-air-nav-pro.jpeg', altText: 'Air Navigation Pro', link: airNavProLink };
    }
    default:
      throw new Error(`MapLinkServices ${String(service)} is not supported!`);
  }
}
